/* eslint-disable max-len */
import { WordsListTranslations } from '../interfaces/words-list';

const EnglishWordsListTranslations: WordsListTranslations = {
  itemsCount: {
    one: '{{n}} item',
    few: '{{n}} items',
    many: '{{n}} items',
  },
  photo: {
    messages: {
      success: 'Photo added',
      error: 'Could not add the photo',
    },
  },
  button: {
    create: 'Add list',
    save: 'Save changes',
    saved: 'Saved',
    addWord: 'Add',
  },
  save: {
    messages: {
      success: 'The list has been saved',
      error: 'Could not save the list',
    },
  },
  add: {
    title: 'Add list',
    messages: {
      success: 'New list added',
      error: 'Could not add a new list. Please try again in a moment.',
    },
  },
  edit: {
    title: 'Editing',
    messages: {
      success: 'List edited',
      error: 'Could not edit the list. Please try again in a moment.',
    },
  },
  share: {
    title: 'Share',
    description: 'Select who you want to share the list with',
    submit: 'Share',
    cancel: 'Cancel',
    messages: {
      success: 'The list has been shared',
      error: 'Could not share the list',
    },
    students: 'Students',
    groups: 'Groups',
    sharedCountTitle: 'How many students have this list',
    countOf: '{{n}} of {{total}}',
    emptyGroup: 'empty',
    loading: 'Loading shares...',
    loadError: 'Error while loading shares',
    shared: 'List shared',
    revoked: 'Sharing withdrawn',
    changeError: 'Error while changing sharing',
    groupShared: {
      one: 'Shared with {{n}} student from the group “{{group}}”',
      few: 'Shared with {{n}} students from the group “{{group}}”',
      many: 'Shared with {{n}} students from the group “{{group}}”',
    },
    groupAllHave: 'Everyone in the group “{{group}}” already has this list',
    groupShareError: 'Could not share the list with the group',
    groupRevoked: {
      one: 'Sharing withdrawn from {{n}} student in the group “{{group}}”',
      few: 'Sharing withdrawn from {{n}} students in the group “{{group}}”',
      many: 'Sharing withdrawn from {{n}} students in the group “{{group}}”',
    },
    groupNoneHad: 'Nobody in the group “{{group}}” had this list',
    groupRevokeError: 'Could not withdraw sharing from the group',
    revokeGroup: {
      title: 'Withdraw sharing from the group “{{group}}”?',
      losing: 'The list “{{list}}” will disappear for:',
      alsoOthers: 'Also for those who got it separately or through another group.',
      ok: 'Withdraw',
    },
    groupCounterHint: 'The counter next to a group: how many of its students have this list — including those who got it separately or through another group. ',
    savedInstantly: 'Every click is saved immediately.',
  },
  lists: {
    tabs: {
      folders: 'Folders',
      lists: 'Lists',
    },
    count: 'number of lists',
    itemsTooltip: 'number of items',
    edit: 'Edit the list {{list}}',
    editTooltip: 'edit list',
    share: 'Share the list {{list}}',
    shareTooltip: 'share',
    delete: 'Delete the list {{list}}',
    deleteTooltip: 'delete the whole list',
  },
  studentLists: {
    title: 'My lists',
    empty: 'You have no lists yet.',
    emptyHint: 'When your teacher shares a list with you, it will appear here.',
    unavailable: 'The list “{{list}}” is no longer available.',
    tooFewWords: 'The list “{{list}}” has too few words to play with.',
  },
  editor: {
    namePlaceholder: 'list name',
    descriptionPlaceholder: 'list description',
    syncing: 'Synchronising data...',
    syncError: 'Data synchronisation error. Refresh the page.',
  },
  editTerm: {
    title: 'Edit the phrase',
    termPlaceholder: 'Type the term',
    definitionPlaceholder: 'Type the definition',
    messages: {
      emptyTerm: 'The term cannot be empty',
      cannotUpdate: 'Cannot update the term',
      wordRemoved: 'This word has been removed from the list; the change was not saved',
      error: 'Could not update the term',
    },
  },
  // Podpisy zdjęć z Unsplash: „fot. Autor · Unsplash”, „Zdjęcia: A, B i inni / Unsplash”
  credits: {
    photoBy: 'photo:',
    photosFrom: 'Photos from',
    photos: 'Photos:',
    andOthers: ' and others',
  },
  // Wskazówka w oknie FOTO: quickAdd pogrubione, quickAddRest zaraz po nim
  screenshot: {
    title: 'SCREENSHOT',
    quickAdd: '💡 Quick adding',
    quickAddRest: ' — works only while this window (PHOTO) is open.',
    noNeedToExpand: 'You do not need to expand these instructions.',
    dragStep: '1/ drag the image anywhere onto the page',
    pasteStep: '2/ or copy the image and paste it (Ctrl+V, on a Mac Cmd+V)',
    instant: 'The image goes straight to the word — even if you paste it by accident.',
    shortcuts: 'Keyboard shortcuts for taking screenshots on your device: ',
    windows: 'Win + Shift + S  →  select an area → paste (Ctrl+V) on the app screen',
    macos: 'Cmd + Shift + 4  →  select an area → drag the clipping onto the app screen',
    uploading: 'Uploading the screenshot...',
    uploaded: 'Screenshot added! 🎉',
    uploadError: 'Error while uploading the screenshot',
  },
  delete: {
    title: 'Delete',
    description: 'Are you sure you want to delete this list?',
    submit: 'Delete',
    cancel: 'Cancel',
    messages: {
      success: 'The list has been deleted',
      error: 'Could not delete the list',
    },
  },
  images: {
    select: 'PHOTO',
    loadFromComputer: 'Upload your own photo',
    findInPhotoBank: 'Get one from the photo bank',
    morePhotos: 'More photos',
    selectPhoto: 'Select a photo',
    badFormat: 'You can only upload JPG or PNG files!',
    tooBig: 'The file is too big! The maximum size is {{mb}} MB.',
    errors: {
      rateLimit: 'The photo search limit has been used up. Try again in a few minutes.',
      unavailable: 'The photo bank is temporarily unavailable. Try again in a moment.',
      notConfigured: 'Photo search is not configured in this environment.',
      photoNotFound: 'This photo has disappeared from the photo bank. Choose another one.',
      generic: 'Could not load photos. Please try again.',
    },
  },
  catalog: {
    word: {
      add: '★ To catalogue',
      addHint: 'add to the catalogue',
      inCatalog: 'In the catalogue',
      unsplash: 'The catalogue accepts only your own images.',
      noAsset: 'Upload this image again so that it can be added to the catalogue.',
      noTerm: 'Fill in the phrase (up to 200 characters).',
    },
    messages: {
      added: 'Added to the catalogue',
      restored: 'Restored to the catalogue',
    },
    fill: {
      button: 'Fill in ({{missing}})',
      hint: 'Click if the missing images should be added automatically from the image catalogue, as long as the term/phrase is there. Otherwise, add the image yourself.',
      success: 'Filled in from the catalogue: {{filled}} of {{total}}.',
      empty: 'The catalogue has no images for these words yet.',
      error: 'Could not get images from the catalogue. Please try again.',
    },
    errors: {
      notCurator: 'This account has no access to the catalogue.',
      noTerm: 'Fill in the phrase.',
      sourceNotEligible: 'The catalogue accepts only your own images.',
      assetNotFound: 'You can only add an image you have uploaded yourself.',
      entryExists: 'This pair is already in the catalogue.',
      entryNotFound: 'This entry is no longer in the catalogue.',
      generic: 'Something went wrong. Please try again.',
    },
    entries: {
      title: 'Image catalogue',
      search: 'Search the catalogue',
      clearSearch: 'Clear search',
      termPlaceholder: 'Type a word or phrase that matches the image',
      imageHint: 'Paste or drag',
      uploadFromDisk: 'Upload from disk',
      uploadError: 'Could not prepare the image. Please try again.',
      add: 'Add to catalogue',
      empty: 'The catalogue is empty. Add the first image above or with the “To catalogue” button next to a word on a list.',
      noMatch: 'No phrase matches the search.',
      countTooltip: 'number of items in the catalogue',
      countFilteredTooltip: 'matching the search / all items',
      withdraw: 'Delete',
      cancel: 'Cancel',
      withdrawConfirm: 'Remove this image from the catalogue?\nTeachers who have already used it will keep it on their lists.',
      withdrawSuccess: 'Removed from the catalogue',
      editTerm: 'Correct the phrase',
      editSuccess: 'Phrase corrected',
      mergeTitle: 'The phrase “{{term}}” is already in the catalogue',
      mergeContent: 'Merge both rows? After that, every correction of the phrase will move all their images together.',
      merge: 'Merge',
      noImage: 'no image',
      notCurator: 'This view is available only to catalogue curators.',
    },
  },
  card: {
    active: 'active',
    new: 'new',
    tooShort: 'too few items for games',
  },
  wordsListForm: {
    labels: {
      name: 'NAME',
      description: 'DESCRIPTION',
      image: 'image',
      words: 'WORDS',
      items: 'Items',
      term: 'Phrase',
      definition: 'Definition',
      submit: 'Save',
      edit: 'Edit',
    },
    info: {
      wordsEmpty: 'The list is empty',
      wordsEmptyHint: 'Add the first item with the “Add” button below.',
      termRequired: 'Without a phrase the card will not be saved',
      termRequiredSaved: 'Without a phrase the changes in this card will not be saved',
    },
    termRequiredModal: {
      titleOne: 'Fill in the phrase in card {{cards}}',
      titleMany: 'Fill in the phrase in cards: {{cards}}',
      content: 'For the changes to be saved, the phrase is required — type it in or delete the card.',
      ok: 'OK',
    },
    validation: {
      name: {
        required: 'Name is required',
      },
      description: {
        required: 'Description is required',
      },
    },
  },
};

export default EnglishWordsListTranslations;
